var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('progress-header'),_vm._v(" "),_c('search-form',{attrs:{"tracking-name":_vm.trackingName},on:{"search":_vm.search}}),_vm._v(" "),_c('search-tips',{attrs:{"type":"airport_transfers"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }